export default __webpack_public_path__ + "static/media/img-error.85f95e37.svg";